import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import React, { useCallback, useRef, useState } from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';

import Slider from 'react-slick';
import cx from 'classnames';
import useIsMobile from '../../hooks/useIsMobile';

const HeroCarousel = ({ content }) => {
	const query = useStaticQuery(graphql`
		query Banners {
			allGoogleBannersconfigSheet(
				filter: { bannerId: { in: [1, 2, 3, 4, 5, 6, 7, 8] } }
			) {
				edges {
					node {
						order
						imageKey
						link
					}
				}
			}
		}
	`);

	const [activeSlider, setActiveSlider] = useState(0);
	const slider = useRef(null);
	const isMobile = useIsMobile();

	const regex = /https?:\/\/[^\s]+/;
	const found = content
		.split('<figure')
		.map((text) => {
			const url = text.match(regex);
			if (url) {
				return url[0].replace(/-\d+x\d+(?=\.)/, '');
			}
		})
		.filter(Boolean);

	const settings = {
		dots: true,
		infinite: true,
		speed: 800,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1, // important for clickable dots
		slidesToScroll: 1, // move 1 slide per click
		arrows: false,
		fade: true
	};

	const images_mobile = query.allGoogleBannersconfigSheet.edges
		.filter((banners) => {
			return banners.node.imageKey.includes('mobile');
		})
		.map(({ node }) => ({
			url: found.find((el) => el.includes(node.imageKey)),
			title: "ph",
			linkTo: node.link,
			order: node.order
		}))
		.sort((a, b) => a.order - b.order);

	const images_desktop = query.allGoogleBannersconfigSheet.edges
		.filter((banners) => {
			return banners.node.imageKey.includes('desktop');
		})
		.map(({ node }) => ({
			url: found.find((el) => el.includes(node.imageKey)),
			title: "ph",
			linkTo: node.link,
			order: node.order
		}))
		.sort((a, b) => a.order - b.order);

	const data = isMobile ? images_mobile : images_desktop;

	const goToPage = useCallback(() => {
		navigate(data[activeSlider].linkTo);
	}, [activeSlider, data]);
	return (
		<div
			id="hero-carousel"
			className="container-lg relative additional-styles"
			style={{
				paddingTop: '10rem',
				overflow: 'hidden',
				maxWidth: 1400
			}}
		>
			<Slider {...settings} ref={slider} afterChange={(i) => setActiveSlider(i)}>
				{data.map((img, i) => (
					<div key={i} className="w-full relative">
						<img
							onClick={goToPage}
							src={img.url}
							alt={img.title}
							style={{
								maxWidth: '100%',
								height: 'auto',
								cursor: 'pointer'
							}}
						/>
					</div>
				))}
			</Slider>
			<span
				className={cx('arrow-next', {})}
				onClick={() => slider?.current?.slickNext()}
			/>
			<span
				className={cx('arrow-prev', {})}
				onClick={() => slider?.current?.slickPrev()}
			/>
		</div>
	);
};

export default HeroCarousel;

